import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Field } from "react-final-form";

interface MonthOption {
  value: string;
  label: string;
}

interface YearOption {
  value: number;
  label: number;
}

const months: MonthOption[] = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const START_YEAR = 2018;
const years: YearOption[] = Array.from(
  { length: new Date().getFullYear() - START_YEAR + 1 },
  (_, k) => ({
    value: START_YEAR + k,
    label: START_YEAR + k,
  })
);

interface DateMonthPickerProps {
  name: string;
  label?: string;
  [key: string]: any;
}

export function DateMonthPicker(props: DateMonthPickerProps) {
  return (
    <Field
      {...props}
      render={({ input: { onChange, value }, label }: any) => {
        let [year, month] = value.split("-");

        const onChangeMonth = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.value === null) {
            return onChange(null);
          }

          if (!year) year = new Date().getFullYear();
          onChange(`${year}-${event.target.value}`);
        };

        const onChangeYear = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event.target.value === null) {
            return onChange(null);
          }

          if (!month) month = months[new Date().getMonth()].value;
          onChange(`${event.target.value}-${month}`);
        };

        return (
          <Grid container spacing={1}>
            <Grid size={6}>
              <TextField
                select
                fullWidth
                label={`${label} month`}
                value={month || ""}
                onChange={onChangeMonth}
              >
                <MenuItem value={""}>
                  <em>None</em>
                </MenuItem>
                {months.map((monthOption) => (
                  <MenuItem key={monthOption.value} value={monthOption.value}>
                    {monthOption.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid size={6}>
              <TextField
                select
                fullWidth
                label={`${label} year`}
                value={year || ""}
                onChange={onChangeYear}
              >
                <MenuItem value={""}>
                  <em>None</em>
                </MenuItem>
                {years.map((yearOption) => (
                  <MenuItem key={yearOption.value} value={yearOption.value}>
                    {yearOption.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}
